import React, { useState } from 'react';
import IntroStep from '../../../kiosk-experiences/mbti/src/components/IntroStep/IntroStep';
import TutorialStep from '../../../kiosk-experiences/mbti/src/components/TutorialStep/TutorialStep';
import QuestionStepPreview from '../../../kiosk-experiences/mbti/src/components/QuestionStep/QuestionStepPreview';
import '../../../kiosk-experiences/mbti/src/styles.css';

// Lightweight copy of the English UI text used by the MBTI experience
const uiTextEn = {
  title: 'MBTI MIXOLOGIST',
  subtitle: 'AI crafts the perfect drink to match your unique type!',
  nameLabel: 'Name',
  namePlaceholder: 'Your name',
  startButton: 'Start',
};

const MBTIPlaygroundPage: React.FC = () => {
  const [view, setView] = useState<'intro' | 'tutorial' | 'question'>('intro');
  const [lastIntroResult, setLastIntroResult] = useState<{ name: string; selfieUrl: string } | null>(null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <header style={{ padding: '8px 16px', borderBottom: '1px solid #1f2937', background: '#020617', color: '#e5e7eb' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 960, margin: '0 auto' }}>
          <div style={{ fontWeight: 700 }}>MBTI UI Playground</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="button"
              onClick={() => setView('intro')}
              style={{
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #4b5563',
                background: view === 'intro' ? '#111827' : 'transparent',
                color: '#e5e7eb',
                cursor: 'pointer',
              }}
            >
              Intro
            </button>
            <button
              type="button"
              onClick={() => setView('tutorial')}
              style={{
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #4b5563',
                background: view === 'tutorial' ? '#111827' : 'transparent',
                color: '#e5e7eb',
                cursor: 'pointer',
              }}
            >
              Tutorial
            </button>
            <button
              type="button"
              onClick={() => setView('question')}
              style={{
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #4b5563',
                background: view === 'question' ? '#111827' : 'transparent',
                color: '#e5e7eb',
                cursor: 'pointer',
              }}
            >
              Question
            </button>
          </div>
        </div>
      </header>

      <main style={{ flex: 1, background: '#000' }}>
        <div style={{ height: '100%', width: '100%', position: 'relative', overflow: 'hidden' }}>
          {view === 'intro' && (
            <IntroStep
              instanceId="PLAYGROUND"
              defaultName={lastIntroResult?.name ?? ''}
              defaultSelfieUrl={lastIntroResult?.selfieUrl ?? ''}
              language="en"
              uiText={uiTextEn}
              onComplete={(result) => {
                setLastIntroResult(result);
              }}
            />
          )}

          {view === 'tutorial' && (
            <TutorialStep
              onComplete={() => {
                // no-op in playground; in real flow this would advance to questions
              }}
            />
          )}

          {view === 'question' && (
            <QuestionStepPreview />
          )}
        </div>
      </main>
    </div>
  );
};

export default MBTIPlaygroundPage;
